// ================================
// INSTALL PROMPT
// Dismissible "add to home screen" card. On Android/Chrome/Edge this is a
// real one-tap install; on iOS Safari there's no programmatic trigger, so
// it shows the manual Share -> Add to Home Screen steps instead. Renders
// nothing once installed, on unsupported desktop browsers, or after the
// user closes it (remembered per-device via localStorage).
// ================================
import React, { useState } from 'react';
import useInstallPrompt from '../../utils/useInstallPrompt';

const DISMISS_KEY = 'ww_install_dismissed';

export default function InstallPrompt() {
  const { canInstall, standalone, ios, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });
  const [installing, setInstalling] = useState(false);

  if (standalone || dismissed) return null;
  if (!canInstall && !ios) return null;

  function dismiss() {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
  }

  async function handleInstall() {
    setInstalling(true);
    const choice = await promptInstall();
    setInstalling(false);
    if (choice?.outcome === 'accepted') dismiss();
  }

  return (
    <div style={{
      margin: '0 20px 14px', background: 'var(--bg-card)',
      border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)',
      padding: '12px 14px', position: 'relative'
    }}>
      <button onClick={dismiss} aria-label="Dismiss"
        style={{ position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 16, cursor: 'pointer', lineHeight: 1 }}>
        ✕
      </button>

      <p style={{ fontSize: 13, color: 'var(--text-primary)', marginBottom: 4, paddingRight: 20 }}>📲 Add to Home Screen</p>

      {canInstall && (
        <>
          <p style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 10 }}>
            Install Weedo World for faster access and delivery alerts, even when your browser's closed.
          </p>
          <button onClick={handleInstall} disabled={installing} style={{
            padding: '8px 16px', borderRadius: 'var(--radius-sm)', border: 'none',
            background: 'var(--accent-blue)', color: '#fff', fontSize: 13, cursor: 'pointer'
          }}>
            {installing ? 'Installing…' : 'Install App'}
          </button>
        </>
      )}

      {!canInstall && ios && (
        <p style={{ fontSize: 11, color: 'var(--text-secondary)' }}>
          Tap the <strong>Share</strong> icon (⬆️ in the Safari toolbar), then <strong>Add to Home Screen</strong> — that's also what lets you get delivery alerts with the app closed.
        </p>
      )}
    </div>
  );
}
